/**
 * Homepage transparent/overlapping header (live theme's `header_overlap`).
 *
 * Mirrors theme.js.liquid `navStickyScroll`: while the visitor has scrolled
 * less than half the viewport height, the header stays transparent and
 * scrolls away with the hero; past that threshold it comes back as a fixed
 * bar with the solid header background (live `.nav-sticky`).
 */
const header = document.querySelector('.header--overlap');

if (header) {
  let ticking = false;

  const update = () => {
    header.classList.toggle('header--scrolled', window.scrollY > window.innerHeight * 0.5);
    ticking = false;
  };

  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    },
    { passive: true }
  );

  update();
}
